module.exports = __webpack_public_path__ + "img/cat_sanofiaventis.c1bec932.jpg";